export const initialPopupContent = {
  txn: {
    hash: '',
    success: false,
    summary: '',
    linkRemove: true
  }
}

export function NFTBuyCallBackHandle(e: any, success: boolean): any {
  //balance error
  let message = 'NFT Buy Error'

  if (e && e.code === -32603) {
    message = 'The balance is insufficient'
  }

  return {
    txn: { ...initialPopupContent.txn, success, summary: message }
  }
}

export function NFTSellPriceError() {
  return {
    txn: { ...initialPopupContent.txn, success: false, summary: 'Price must be bigger than zero' }
  }
}

export function PopupMessage(message: string, success = true): any {
  return {
    txn: { ...initialPopupContent.txn, success, summary: message }
  }
}
